import type { User } from '@/types'

export function collectRoleCodes(user: User | null): string[] {
  if (!user) {
    return []
  }
  const codes: string[] = []
  if (user.primaryRoleCode) {
    codes.push(user.primaryRoleCode)
  }
  if (user.role) {
    codes.push(user.role)
  }
  if (user.roles?.length) {
    for (const r of user.roles) {
      if (r.code) {
        codes.push(r.code)
      }
    }
  }
  return codes.map((c) => c.toUpperCase())
}

/** 可访问 /api/platform 与 /ops 控制台的角色（与后端 JWT / MethodSecurity 对齐） */
export function isPlatformOperator(user: User | null): boolean {
  return collectRoleCodes(user).some((c) => c === 'SUPER_ADMIN' || c === 'PLATFORM_ADMIN')
}
